export default __webpack_public_path__ + "static/media/pxec04-web.8f281256.png";